import { OnChange } from '@frontendlib/common/decorators/on-change';
import { BaseStitchListState } from '@modules/common/types/base-stitch-list-state';
import { type SortBy } from '@modules/common/types/SortBy';
import { SortOrder } from '@modules/common/types/sort-order';
import { type FormFolderStitch, type FormStitch } from './form-stitch';

export type FormsKpItem = FormStitch | FormFolderStitch;
export type FormsListSortField = 'title' | 'createdAt' | 'updatedAt' | 'score';

/** Native KP state; Forms' main and dynamic-panel navigation remain in their existing workspace store. */
export class FormsKpListState extends BaseStitchListState<FormsKpItem, FormsListSortField> {
  @OnChange('onPropertyChange')
  declare public sortBy?: FormsListSortField;

  public constructor(defaultSort: SortBy<FormsListSortField> = { by: 'score', order: SortOrder.DESC }) {
    super({ defaultSort });
  }
}
